import { useTranslation } from 'react-i18next'

const Hero = () => {
  const { t } = useTranslation()

  return (
    <section className="relative min-h-screen flex items-center justify-center px-6 pt-16">
      {/* Animated skill network visualization */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <svg className="w-full h-full" preserveAspectRatio="xMidYMid slice">
          <defs>
            <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#d4a574" stopOpacity="0.2" />
              <stop offset="100%" stopColor="#d4a574" stopOpacity="0" />
            </linearGradient>
          </defs>

          {/* Connection lines */}
          <g stroke="url(#lineGradient)" strokeWidth="1" fill="none" className="animate-draw-line">
            <path d="M200,400 Q400,300 600,400 T1000,400" strokeDasharray="1000" strokeDashoffset="1000" />
            <path d="M150,500 Q350,400 550,500 T950,500" strokeDasharray="1000" strokeDashoffset="1000" style={{ animationDelay: '0.3s' }} />
            <path d="M250,600 Q450,500 650,600 T1050,600" strokeDasharray="1000" strokeDashoffset="1000" style={{ animationDelay: '0.6s' }} />
          </g>

          {/* Node clusters */}
          <g className="animate-node-glow">
            <circle cx="200" cy="400" r="8" fill="#d4a574" opacity="0.6" />
            <circle cx="220" cy="380" r="4" fill="#d4a574" opacity="0.4" />
            <circle cx="180" cy="420" r="5" fill="#d4a574" opacity="0.3" />
          </g>

          <g className="animate-node-glow-delayed">
            <circle cx="600" cy="400" r="10" fill="#d4a574" opacity="0.5" />
            <circle cx="580" cy="420" r="4" fill="#d4a574" opacity="0.3" />
            <circle cx="630" cy="390" r="3" fill="#d4a574" opacity="0.4" />
          </g>

          <g style={{ animation: 'nodeGlow 3s ease-in-out 1s infinite' }}>
            <circle cx="1000" cy="400" r="7" fill="#d4a574" opacity="0.5" />
            <circle cx="980" cy="380" r="4" fill="#d4a574" opacity="0.3" />
            <circle cx="1020" cy="420" r="5" fill="#d4a574" opacity="0.4" />
          </g>
        </svg>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        {/* Badge */}
        <div
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-crafter-accent/20 bg-crafter-surface/50 backdrop-blur-sm mb-8 animate-fade-in-up"
          style={{ animationDelay: '0.1s' }}
        >
          <span className="w-2 h-2 rounded-full bg-crafter-accent animate-pulse" />
          <span className="font-mono text-xs text-crafter-accent">{t('hero.badge')}</span>
        </div>

        {/* Heading */}
        <h1
          className="font-sans font-bold text-5xl md:text-7xl lg:text-8xl tracking-tight mb-6 animate-fade-in-up"
          style={{ animationDelay: '0.2s' }}
        >
          <span className="block text-crafter-text">{t('hero.heading')}</span>
          <span className="block gradient-text mt-2">{t('hero.headingHighlight')}</span>
        </h1>

        {/* Subheading */}
        <p
          className="font-sans text-xl md:text-2xl text-crafter-textDim max-w-2xl mx-auto mb-12 leading-relaxed animate-fade-in-up"
          style={{ animationDelay: '0.3s' }}
        >
          {t('hero.description')}
        </p>

        {/* CTA Button */}
        <div
          className="flex items-center justify-center animate-fade-in-up"
          style={{ animationDelay: '0.4s' }}
        >
          <a
            href="#features"
            className="group relative px-8 py-4 bg-crafter-accent text-crafter-base font-sans font-semibold rounded-lg overflow-hidden transition-all hover:shadow-lg hover:shadow-crafter-accent/20"
          >
            <span className="relative z-10">{t('hero.exploreFeatures')}</span>
            <div className="absolute inset-0 bg-crafter-accentLight transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300" />
          </a>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
          <svg
            className="w-6 h-6 text-crafter-accent/50"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </div>
    </section>
  )
}

export default Hero
